





































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Character from '@/classes/character/character.ts';
import { Talents, TalentField } from '@/classes/character/allValues.ts';
import Talent from '@/classes/attributes/talent.ts';
import TalentCollection from '@/classes/attributes/talentCollection.ts';
import TalentFieldObject from '@/classes/attributes/talentFieldObject.ts';

@Component
export default class CharacterWizard extends Vue {
  @Prop()
  public characterId: string | null = null;

  public step: number = 0;
  public valid: boolean = false;
  public character: Character = new Character();
  public talentCollection: TalentCollection = new TalentCollection();
  public loading: boolean = true;
  public classes: string[] = [
    'Scioppo Incanto',
    'Harpye',
    'Talhüter',
    'Nebelkrähe',
    'Kaskarier',
    'Argunath',
  ];
  public steps: string[] = [
    'Basis',
    'Grundwerte',
    'Attribute',
    'Elemente',
    'Talente',
    'Manöver',
    'Mystiken',
  ];
  public allTalents: Talent[] = Talents;

  public created() {
    if (this.characterId !== null) {
      this.$store.dispatch('loadCharacter', this.characterId).then(() => {
        this.loading = false;
      });
    } else {
      this.loading = false;
      this.character.init();
    }
  }

  get allTalentfields(): TalentFieldObject[] {
    return this.talentCollection.getAllTalentFields();
  }

  public talentsByTalentField(field: TalentField): Talent[] {
    return this.talentCollection.getTalentsByTalentField(field);
  }

  public setBaseValue(abbreviation: string, value: string) {
    this.character.setValueByAbbreviation(abbreviation, parseInt(value, 10));
  }
}
